import { ComposedTheme } from '@glu/theming';

const styles = ({ spacing: { unit } }: ComposedTheme) => ({
  buttonLink: {
    '&.btn.btn-link': {
      paddingLeft: 0
    }
  },

  checkLabel: {
    fontWeight: 'normal',
    '& [type=checkbox]': {
      marginRight: unit
    }
  }
});

export default styles;
